export default (context = {}) =>
  fieldLibrary = {
    fieldGroups: {
      bulk: {
        _requiredFields: ['name']
        creative:
          name: 'Experience'
          description: ''
          fieldKeys: ['title', 'primary_type', 'types', 'audience_tags', 'activity_tags', 'demographics', 'contacts', 'special_terms', 'engagement_capacity', 'images']
        venue:
          name: 'Venue'
          description: ''
          fieldKeys: ['onsite_permissions', 'occupancy_count', 'storage_facilities_available', 'storage_capacity', 'venue_local_terms', 'past_relevant_dates']
        calendar:
          name: 'Calendar'
          description: ''
          fieldKeys: ['seasons', 'blockout_dates']
        partnershipDetails:
          name: 'Partnership Details'
          description: ''
          fieldKeys: ['pitch', 'sponsor_set', `/*'cancelation_policy',*/` 'preferred_brand_categories', 'sold_out', 'catex']
      }
    }
    fields: {
      title: {
        name: 'Title',
        component: 'text',
        inputProps: {
          placeholder: 'Title',
        },
        options: {
          instructions: 'Override the name of your experience or event',
          why: 'Set this only if its different at this location(s)'
        }
      },
      primary_type: {
        name: 'Primary Type',
        component: 'select',
        inputProps: {
          placeholder: 'Primary Type',
        },
        options: {
          instructions: 'Override how you would primarily categorize this experience',
        }
      },
      types: {
        name: 'Additional Types',
        component: 'tags',
        inputProps: {
          placeholder: 'Search...',
          limit: 3,
        },
        options: {
          instructions: 'Override thee additional categories to help describe this experience (up to 3)',
        }
      },
      audience_tags: {
        name: 'Audience Types',
        component: 'tags',
        inputProps: {
          placeholder: 'Search...',
          limit: 3,
        },
        options: {
          instructions: 'Override the kind of people who will attending (up to 3)',
        }
      },
      activity_tags: {
        name: 'Activity Types',
        component: 'tags',
        inputProps: {
          placeholder: 'Search...',
          limit: 3,
        },
        options: {
          instructions: 'Override the activities that attendees will engage in (select up to 3)',
        }
      },
      demographics: {
        name: 'Demographics',
        component: 'demographics',
        options: {
          instructions: 'Override the demographics that a sponsor can reach',
          why: 'Set this only if its different at this location(s)'
        }
      },
      contacts: {
        name: 'Contact Information',
        component: 'contact-set',
        options: {
          instructions: 'Set specific contacts for this location'
        }
      },
      special_terms: {
        name: 'Special Terms',
        component: 'textarea',
        inputProps: {
          placeholder: 'Describe any special terms'
        },
        options: {
          instructions: 'Override any special terms',
          why: 'Set this only if its different at this location(s)'
        }
      },
      engagement_capacity: {
        name: 'Inventory Capacity',
        component: 'inventory-capacity',
        options: {
          hideName: true,
          why: 'Set this only if its different at this location(s)'
        }
      },
      posting_platforms: {
        name: 'Posting Platforms'
        component: 'posting-platforms'
        options: {
          instructions: 'Let brands know which platforms are available for them to post a messaage'
        }
      },
      images: {
        name: 'Media',
        component: 'media',
        options: {
          instructions: 'Let Sponsors know who is hosting the experience',
          why: 'Set this only if its different at this location(s)'
        }
      },
      onsite_permissions: {
        name: 'Onsite Permissions',
        component: 'switch',
        inputProps: {
          items: [
            {
              key: 'vehicles_allowed'
              label: 'Vehicles Allowed'
              description: 'Vendors are allowed to drive vehicles onto the activation space location (ex: food truck, trailer, branded vehicle part of set up)'
            },
            {
              key: 'sales_allowed'
              label: 'Selling Products or Services Allowed'
              description: 'Vendors are allowed to sell items or services (ex: merchandise, food & beverage)'
            },
            {
              key: 'glass_allowed'
              label: 'Glass Bottles or Containers Not Allowed'
              description: 'Vendors are not allowed to distribute in glass bottles (ex: drinks)'
            },
          ]
        },
      },
      occupancy_count: {
        name: 'Occupancy',
        component: 'text-grid',
        inputProps: {
          cols: 2
          items: [
            {
              key: 'delivery_points'
              label: 'Delivery Points'
              description: '# of delivery points at this venue'
              placeholder: '# of delivery points'
            }
            {
              key: 'delivery_label'
              label: 'Delivery Label'
              description: 'Label for delivery points'
              placeholder: 'Label for delivery points'
            }
            {
              key: 'resident_count'
              label: 'Number of Residences'
              description: '# of people at this venue'
              placeholder: '# of people'
            }
          ]
        },
        options: {
          instructions: 'Override the information about the attendees',
          why: 'Set this only if its different at this location(s)'
        }
      },
      storage_facilities_available: {
        name: 'Available Storage',
        component: 'storage',
        options: {
          instructions: 'Select the primary type for the listing',
          why: 'Set this only if its different at this location(s)'
        }
      },
      storage_capacity: {
        name: 'Storage Capacity',
        component: 'text-grid',
        inputProps: {
          cols: 2
          items: [
            {
              key: 'cold_storage_count'
              label: 'Cold Storage Capacity'
              description: '# of items available to be stored in cold storage'
              placeholder: 'ex: # of 12oz cans'
            },
            {
              key: 'frozen_storage_capacity'
              label: 'Frozen Storage Capacity'
              description: '# of items available to be stored in frozen storage'
              placeholder: 'ex: # of ice cream bars'
            }
          ]
        },
        options: {
          instructions: 'Override the size of storage facilities',
          why: 'Set this only if its different at this location(s)'
        }
      },
      venue_local_terms: {
        name: 'Venue Local Terms',
        component: 'textarea',
        inputProps: {
          placeholder: 'Describe any special terms'
        },
        options: {
          instructions: 'Set a special term',
          why: 'Set this only if its different at this location(s)'
        }
      },
      seasons: {
        name: 'Seasonal',
        component: 'seasons',
        options: {
          instructions: 'List any categories where you already have an exclusive partnership with a brand',
          why: 'Set this only if its different at this location(s)'
        }
      },
      blockout_dates: {
        name: 'Blockout Dates',
        component: 'blockout-dates',
        options: {
          instructions: 'Dates when sponsorships are unavailable',
          why: 'Set this only if its different at this location(s)'
        }
      },
      pitch: {
        name: 'Pitch',
        component: 'editor',
        inputProps: {
          placeholder: 'Listing description',
        },
        options: {
          instructions: 'Brief elevator pitch to help Sponsors understand this Opportunity',
          why: 'Set this only if its different at this location(s)'
        }
      },
      sponsor_set: {
        name: 'Brand Partners',
        component: 'brand-select',
        options: {
          instructions: 'List any past sponsor you have worked with.'
        }
      },
      cancelation_policy: {
        name: 'Cancellation Policy',
        component: 'cancellation-policy',
        options: {
          instructions: 'Set a cancellation policy',
          why: 'Set this only if its different at this location(s)'
        }
      },
      preferred_brand_categories: {
        name: 'Preferred Brand Categories',
        component: 'tags',
        inputProps: {
          placeholder: 'Tags'
        },
        options: {
          instructions: 'Let Sponsors know who is hosting the experience',
          why: 'Set this only if its different at this location(s)'
        }
      },
      sold_out: {
        name: 'Sold Out',
        component: 'switch',
        inputProps: {
          items: [
            {
              key: 'sold_out'
              activeLabel: 'Sold Out'
              inactiveLabel: 'Not Sold Out'
            },
          ]
        },
        options: {
          instructions: 'Let sponsors know if this experience is temporarily sold out',
          why: 'Set this only if its different at this location(s)'
        }
      },
      catex: {
        name: 'Categories',
        component: 'catex-select',
        options: {
          hideName: true,
          why: 'Set this only if its different at this location(s)'
        }
      },
      past_relevant_dates: {
        name: 'Past Relevant Dates'
        component: 'past-relevant-dates'
        options: {
          instructions: 'Specify your past relevant dates'
        }
      }
    }
  }

  library = JSON.parse(JSON.stringify(fieldLibrary))

  for key, field of library.fields
    field.inputProps ||= context.inputProps?[key] || {}
    field.inputProps?.options ||= context.options?[key]
    field.options?.required = key in (context._requiredFields || [])

  library
